module.exports = __webpack_public_path__ + "static/media/kimberly_english_us.bd64a312.mp3";